import { TDynamicStoreField } from '../../../store/store';
import { COOKIE_NAMES } from '../../../utils/constants';
import { getCookieByName } from '../../../utils/cookies';
import { currentCountryMarketInfo } from '../../../utils/countries';
import { gatekeeper } from '../../../utils/gatekeeper';
import { separateBirthdate } from '../../../utils/utils';

export class DGOJ {
  email: string;
  firstName: string;
  lastName: string;
  secondLastName: string;
  phonePrefix: string;
  phoneNumber: string;
  phoneVerified: boolean;
  socialSecurityNumber: string;
  identityDocumentType: 'DNI' | 'NIE';
  dayOfBirth: number;
  monthOfBirth: number;
  yearOfBirth: number;
  gender: string;
  address: {
    country: string;
    city: string;
    streetName: string;
    houseNumber: string;
    postalCode: string;
    isVerified: boolean;
  };
  fiscalRegion: string;
  nationality: string;
  plainTextPassword: string;
  welcomeOfferId?: string;
  trackingId: string;
  marketCode: string;
  subscribeToMarketingMaterial: boolean;

  constructor(data: TDynamicStoreField | null) {
    if (!data) throw new Error('Data is required to instantiate DGOJ.');
    const { dayOfBirth, monthOfBirth, yearOfBirth } =
    separateBirthdate(data.dateOfBirth) || {};
    const countryInfo = currentCountryMarketInfo(
      gatekeeper?.localisation?.marketSlug,
    );

    if (!dayOfBirth || !monthOfBirth || !yearOfBirth) {
      throw new Error('Day, month, and year of birth are mandatory.');
    }
    this.email = data.email?.trim();
    this.firstName = data.firstName?.trim();
    this.lastName = data.lastName?.trim();
    this.secondLastName = data.secondLastName?.trim();
    this.plainTextPassword = data.plainTextPassword?.trim();
    this.phonePrefix = data.phonePrefix;
    this.phoneNumber = data.phoneNumber?.trim();
    this.phoneVerified = false;
    this.identityDocumentType = data.NIE ? 'NIE' : 'DNI';
    this.socialSecurityNumber = data.DNI || data.NIE || '';
    this.dayOfBirth = dayOfBirth;
    this.monthOfBirth = monthOfBirth;
    this.yearOfBirth = yearOfBirth;
    this.gender = data.gender?.toUpperCase();
    this.fiscalRegion = data.region;
    this.nationality = data.nationality?.trim();
    this.welcomeOfferId = data.welcomeOffer;
    this.trackingId = getCookieByName(COOKIE_NAMES.KAZUMO_TRACKING_ID) ?? '';
    this.marketCode = countryInfo?.marketCode ?? '';
    this.subscribeToMarketingMaterial =
      data.subscribeToMarketingMaterial ?? false;

    if (
      !data.countryOfResidence ||
      !data.city ||
      !data.postcode ||
      !data.street ||
      !data.houseNumber
    ) {
      throw new Error('All address fields are mandatory.');
    }

    this.address = {
      country:     data.countryOfResidence.trim(),
      city:        data.city.trim(),
      streetName:  data.street.trim(),
      houseNumber: data.houseNumber.trim(),
      postalCode:  data.postcode.trim(),
      isVerified:  true,
    };

  }

  get data() {
    return { ...this };
  }
}
